import React, {useState, useEffect} from "react"
import VisNetworkReactComponent from "vis-network-react";

let drawingOptions = {
  autoResize: true,
  height: '100%',
  nodes: {
      shape: "dot",
      // size: 6,
      font:{
        size: 6
      }
  },
  physics: {
      forceAtlas2Based: {
          gravitationalConstant: -5,
          centralGravity: 0.01,
          springLength: 30,
          springConstant: 2,
      },
      maxVelocity: 100,
      solver: "forceAtlas2Based",
      timestep: 0.5,
      stabilization: { iterations: 100 },
  },
  edges: {
      arrows: {
          to: { enabled: true, scaleFactor: 0.5, type: "arrow" }
      }
  }
};

let events = {
  click: function (params) {
    params.event = "[original event]";
    console.log(
      "click event, getNodeAt returns: " + this.getNodeAt(params.pointer.DOM)
    );
  },
  doubleClick: function (params) {
    console.log("doubleClick Event:", params);
    params.event = "[original event]";
  },
  oncontext: function (params) {
    console.log("oncontext Event:", params);

    params.event = "[original event]";
  },
  dragStart: function (params) {
    // There's no point in displaying this event on screen, it gets immediately overwritten
    params.event = "[original event]";
    console.log("dragStart Event:", params);
    console.log(
      "dragStart event, getNodeAt returns: " +
        this.getNodeAt(params.pointer.DOM)
    );
  },
  dragging: function (params) {
    params.event = "[original event]";
  },
  dragEnd: function (params) {
    params.event = "[original event]";
    console.log("dragEnd Event:", params);
    console.log(
      "dragEnd event, getNodeAt returns: " + this.getNodeAt(params.pointer.DOM)
    );
  },
  controlNodeDragging: function (params) {
    params.event = "[original event]";
  },
  controlNodeDragEnd: function (params) {
    params.event = "[original event]";
    console.log("controlNodeDragEnd Event:", params);
  },
  zoom: function (params) {},
  showPopup: function (params) {},
  hidePopup: function () {
    console.log("hidePopup Event");
  },
  select: function (params) {
    console.log("select Event:", params);
  },
  selectNode: function (params) {
    console.log("selectNode Event:", params);
  },
  selectEdge: function (params) {
    console.log("selectEdge Event:", params);
  },
  deselectNode: function (params) {
    console.log("deselectNode Event:", params);
  },
  deselectEdge: function (params) {
    console.log("deselectEdge Event:", params);
  },
  hoverNode: function (params) {
    console.log("hoverNode Event:", params);
  },
  hoverEdge: function (params) {
    console.log("hoverEdge Event:", params);
  },
  blurNode: function (params) {
    console.log("blurNode Event:", params);
  },
  blurEdge: function (params) {
    console.log("blurEdge Event:", params);
  },
};

function Graph({data}) {

  const [graphData, setGraphData] = useState({});


  const create_edge_list = (data) => {
    let nodes = [];
    let edges = [];
    for (var i=0; i<data.length;i++) {
      let submission = data[i];
      let node = {
        'id': submission.id, 
        'label': submission.name,
        'color': "#EF4444",
        'size': 3
      }
      if (submission.registered){
        node.color = "#10B981";
        node.size = 5
      }
      if (submission.status ==="PendingRegistration"){
        node.color = "#F59E0B";
        node.size = 4
      }
      nodes.push(node) ;
      if (submission.vouched_list.length >0) {
        for (var j=0; j<submission.vouched_list.length;j++){
          let vouchee = submission.vouched_list[j];
          let edge = {
                'from': node.id,
                'to': vouchee
              }
          edges.push(edge);
        }
      }     
    }
    setGraphData({'nodes': nodes, 'edges':edges})
  }

  useEffect( () => {
    if( Object.keys(graphData).length === 0){
      create_edge_list(data);
    }
  })

  return (
    <div className="h-full">
      <VisNetworkReactComponent
        data={graphData}
        options={drawingOptions}
        events={events}
      />
    </div>
  );
}

export default Graph;